import { useState } from "react";
import { Landmark } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import FreeQuoteModal from "@/components/FreeQuoteModal";
import { useT } from "@/i18n/LanguageContext";

/**
 * Standalone CTA that opens the Stoic Reflection modal — a small,
 * complete preview of the Virtue Guide experience for site visitors.
 */
export default function FreeQuoteCta({ align = "start", className = "" }) {
  const [open, setOpen] = useState(false);
  const { t } = useT();

  const handleClick = () => {
    trackEvent("free_stoic_quote_click", {
      placement: "hero_under_store_badges",
    });
    setOpen(true);
  };

  return (
    <>
      <div
        data-testid="free-quote-cta-wrapper"
        className={`flex ${align === "center" ? "justify-center" : "justify-start"} ${className}`}
      >
        <button
          type="button"
          onClick={handleClick}
          data-testid="free-quote-cta"
          className="group inline-flex items-center gap-3 text-bone hover:text-gold transition-colors duration-300 py-2"
        >
          <span className="relative inline-flex items-center justify-center w-9 h-9 border border-gold/40 group-hover:border-gold rounded-full transition-colors">
            <Landmark size={15} strokeWidth={1.5} color="#C5A059" />
          </span>
          <span className="flex flex-col leading-tight text-left">
            <span className="text-[10px] tracking-[0.28em] uppercase text-gold/80">{t("freeQuote.ctaOverline")}</span>
            <span className="font-serif text-lg md:text-xl tracking-tight">
              {t("freeQuote.ctaLabel")}
              <span className="ml-2 inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
            </span>
          </span>
        </button>
      </div>

      <FreeQuoteModal
        open={open}
        onClose={() => setOpen(false)}
        key={open ? "open" : "closed"}
      />
    </>
  );
}
